import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "ReformulacionDetallePage",
    data() {
        let ss = new MainService();
        return {
            msg: "ReformulacionDetallePage",
            ss: ss,
            ajax: {
                "url": ss.indexReformulacionDetalle(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Reformulacion', name: 'Reformulacion', title: 'Reformulación' },
                { data: 'Reparticion', name: 'Reparticion', title: 'Repartición' },
                { data: 'Partida', name: 'Partida', title: 'Partida' },
                { data: 'CategoriaProgramatica', name: 'CategoriaProgramatica', title: 'Categoría Programática' },
                { data: 'Monto', name: 'Monto', title: 'Monto' },
                { data: 'Tipo', name: 'Tipo', title: 'Tipo', render:function(data, type, row){
                    if (row.Tipo==0) { return 'ORIGEN';                      
                    } else if (row.Tipo==1) { return 'DESTINO';                      
                    } else { return ''; }
                } },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            reformulacions: [],
            reparticions: [],
            partidas: [],
            categoriaprogramaticas: [],
            reformulaciondetalles: [],
            reformulaciondetalle: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        getReformulacion() {
            this.ss.listReformulacion().then(
                (result) => {
                    let response = result.data;
                    this.reformulacions = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getReparticion() {
            this.ss.listReparticion(0).then(
                (result) => {
                    let response = result.data;
                    this.reparticions = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getPartida() {
            this.ss.listPartida().then(
                (result) => {
                    let response = result.data;
                    this.partidas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getCategoriaProgramatica() {
            this.ss.listCategoriaProgramatica().then(
                (result) => {
                    let response = result.data;
                    this.categoriaprogramaticas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newReformulacionDetalle() {
            this.reformulaciondetalle = {};
            this.$refs['frm-reformulaciondetalle'].show();
        },
        showReformulacionDetalle(id) {
            this.isLoading=true;
            this.ss.showReformulacionDetalle(id).then(
                (result) => {
                    let response = result.data;
                    this.reformulaciondetalle = response.data;
                    this.$refs['view-reformulaciondetalle'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editReformulacionDetalle() {
            this.$refs['frm-reformulaciondetalle'].show();
            this.$refs['view-reformulaciondetalle'].hide();
        },
        cancelReformulacionDetalle() {
            if (this.reformulaciondetalle.id) {
                this.$refs['view-reformulaciondetalle'].show();
            }
            this.$refs['frm-reformulaciondetalle'].hide();
        },
        saveReformulacionDetalle() {

            this.ss.storeReformulacionDetalle(this.reformulaciondetalle).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-reformulaciondetalle'].hide();
                    this.$refs['datatable-reformulaciondetalle'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteReformulacionDetalle() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyReformulacionDetalle(this.reformulaciondetalle)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-reformulaciondetalle'].hide();
                                this.$refs['datatable-reformulaciondetalle'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-ReformulacionDetalle').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showReformulacionDetalle(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        } else {
            this.getReformulacion();
            this.getReparticion(0);
            this.getPartida();
            this.getCategoriaProgramatica();
        }
    }
};
